import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getDirectionManagerStart,
  getDirectionManagerSuccess,
  getDirectionManagerFailed,
} from "../redux/getDirectionManager";
import { getDirectionManagerApi } from "core/http/service/timeKeeping";
// import { toast } from "react-toastify";
import { formReqArrivingLateLeaveEarlyUpdate } from "../redux/formReqArrivingLateLeaveEarly";

function* getDirectionManagerWork() {
  try {
    const res = yield call(getDirectionManagerApi);

    yield put({
      type: getDirectionManagerSuccess.type,
      payload: res,
    });
    yield put({
      type: formReqArrivingLateLeaveEarlyUpdate.type,
      payload: {
        approveCode: res?.employeeCode,
        approveName: res?.name,
      },
    });
  } catch (error: any) {
    yield put({
      type: getDirectionManagerFailed.type,
    });
    // toast.error(error?.response?.data?.message || "Đã có lỗi xảy ra!");
  }
}

function* watchGetDirectionManager() {
  yield takeLatest(getDirectionManagerStart.type, getDirectionManagerWork);
}

export default function* getDirectionManagerSaga() {
  yield all([watchGetDirectionManager()]);
}
